import { Box, Grid } from "@mui/material";
import "./Analytics.css";
import BookingAnalytics from "./components/BookingAnalytics";
import { DashboardStats } from "../../../../models/stats";
import { IDock } from "../../../../models/dock";
import { ShipDataBookingsAnalytics } from "./components/ShipDataBookingsAnalytics";
import { DocksAnalytics } from "./components/DocksAnalytics";
import { FeesExpensesAnalytics } from "./components/FeesExpensesAnalytics";
import { ConsumptionAnalytics } from "./components/ConsumptionAnalytics";
import { OnCallAnalytics } from "./components/OnCallAnalytics";
import BookingByStatusAnalytics from "./components/BookingByStatusAnalytics";

type AnalyticsProps = {
    docks: IDock[];
    dashboardStats: DashboardStats;
};

export const Analytics = ({ docks, dashboardStats }: AnalyticsProps) => {
    return (
        <Box className="analytics-container" margin={5}>
            <Grid container>
                <Grid item xs={12} lg={4}>
                    <BookingByStatusAnalytics dashboardStats={dashboardStats} />
                </Grid>
                <Grid item xs={12} lg={8}>
                    <BookingAnalytics dashboardStats={dashboardStats} />
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12} lg={4}>
                    <ShipDataBookingsAnalytics statsCountShips={dashboardStats.countShips} />
                </Grid>
                <Grid item xs={12} lg={8}>
                    <DocksAnalytics
                        docks={docks}
                        statsBerthingsPerDock={dashboardStats.berthingsPerDock}
                    />
                </Grid>
            </Grid>
            <Grid container>
                <Grid item xs={12} lg={4}>
                    <FeesExpensesAnalytics expenseStatsDock={dashboardStats.expenseStatsDock} />
                </Grid>
                <Grid item xs={12} lg={8}>
                    <ConsumptionAnalytics
                        expenseStatsDock={dashboardStats.expenseStatsDock}
                        docks={docks}
                    />
                </Grid>
            </Grid>
            <OnCallAnalytics expenseStatsDock={dashboardStats.expenseStatsDock} />
        </Box>
    );
};
